'use strict';
import { tns } from "../../node_modules/tiny-slider/src/tiny-slider"

class TestimonialSliderUnique {

	constructor($target) {

		//Private properties
        $target;
       
        // console.log($target.find('.block_testimonial_slider_unique__testimonials')[0])


		function init(){
			initSLider()
		}

		function initSLider(){
			var $slidesContainer = $target.find('.block_testimonial_slider_unique__testimonials');
			var windowResiszeTimeout = setTimeout(defineSliderHeight, 1000);
			var slider = tns({
				container: $target.find('.block_testimonial_slider_unique__testimonials')[0],
				loop:true,
				items: 1,
				nav: true,
				autoplay:true,
				autoplayButtonOutput:false,
				autoplayHoverPause: true,
				autoHeight: false,
				controls:false,
				navPosition: 'bottom',
				mode: 'gallery',
				speed: 400,
				slideBy: 'page'
			});

			var dots = $target.find('.tns-nav').children();

			window.onresize = onWindowResize;
			
			defineSliderHeight();

			function onWindowResize(){

				clearTimeout(windowResiszeTimeout)
				windowResiszeTimeout = setTimeout(defineSliderHeight, 1000)

			}

			function defineSliderHeight(){
				//console.log("CLEAR WINDOW RESIZE!");
				let sliderHeight = 0;
				$(slider.getInfo().slideItems).each(function(){
					if(sliderHeight < $(this).height()){
						sliderHeight = $(this).height()
					}
				})
				//console.log(sliderHeight)
				sliderHeight += 50
				$slidesContainer.css("height",sliderHeight+"px");
			}

			return {

				

			}
		}

		init()
		return {

			//Public properties
			name:name,

			publicBlockHero:function(string){

				// $target.append("HELLO!"+string);
				console.log(name)
				console.log(string)
				console.log($target)

			}

		}
	}

}

export default TestimonialSliderUnique;
